//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DepartmentAssessment',
  components: {
    auditProcess: function auditProcess() {
      return import('./components/auditProcess');
    },
    lowerLevel: function lowerLevel() {
      return import('./components/lowerLevel');
    },
    assessStatistics: function assessStatistics() {
      return import('@/views/user/workStatistics/components/assessStatistics');
    }
  },
  data: function data() {
    return {
      tabCur: '4',
      id: 0,
      checkBtn: true,
      isTips: true,
      status: 0,
      isShow: 0,
      strType: '',
      handle: '',
      // 待处理1其他''
      rowData: {},
      tabButton: false
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    addFinance: function addFinance() {
      this.$refs.lower.addFinance();
    },
    saveOk: function saveOk() {
      var _this = this;
      this.checkBtn = true;
      setTimeout(function () {
        _this.$refs.lower.getTableData();
      }, 300);
    },
    lowerHandleCheck: function lowerHandleCheck(res, row, str) {
      if (row) {
        this.rowData = row;
      }
      this.strType = str;
      this.checkBtn = false;
      this.isShow = res.is_show;
      if (res.status == 5) {
        this.status = 0;
      } else {
        this.status = res.status;
      }
      this.id = res.id;
      if (res.addBtn > 1) {
        this.isTips = false;
      } else {
        this.isTips = true;
      }
    },
    tapClick: function tapClick(e) {
      var _this2 = this;
      if (this.tabCur == 3) {
        this.handle = 1;
        setTimeout(function () {
          var _this2$$refs$lower;
          (_this2$$refs$lower = _this2.$refs.lower) === null || _this2$$refs$lower === void 0 ? void 0 : _this2$$refs$lower.getTableData();
        }, 300);
      } else {
        this.handle = '';
        setTimeout(function () {
          var _this2$$refs$lower2;
          (_this2$$refs$lower2 = _this2.$refs.lower) === null || _this2$$refs$lower2 === void 0 ? void 0 : _this2$$refs$lower2.getTableData();
        }, 300);
      }
      this.getList();
    },
    auditProcess: function auditProcess(data) {
      if (data.return == 1) {
        this.checkBtn = true;
        this.tabButton = false;
        this.getList();
      }
    },
    getList: function getList() {
      var _this3 = this;
      setTimeout(function () {
        var tabCur = parseInt(_this3.tabCur);
        if (tabCur == 3 || tabCur == 4) {
          _this3.$refs.lower.handle = tabCur === 3 ? 1 : '';
          _this3.$refs.lower.getFormBoxFrame();
          //判断是否为统计切换时消息

          if (!_this3.tabButton) {
            _this3.$refs.lower.getTableData();
          }
          _this3.tabButton = true;
        } else {
          _this3.tabButton = false;
          _this3.$refs.lowerStatistics.getTableData();
        }
      }, 300);
    }
  }
};